import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── Register cache-busting Service Worker ────────────────────────────────
// Auto-runs on every visit. On new deploys, the SW reinstalls, clears all
// caches, and tells open tabs to reload — fixes "stuck on old version" bug.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-push.js')
      .then((reg) => {
        // If a new version of the SW is found, prompt it to take over immediately
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // A new SW has installed AND an old one was controlling — new deploy detected
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              }
            });
          }
        });
      })
      .catch(() => { /* SW registration failures don't block the app */ });

    // Listen for the "new SW activated" broadcast → hard reload once
    let reloaded = false;
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'SW_UPDATED' && !reloaded) {
        reloaded = true;
        // Small delay so messages flush + UI doesn't ping-pong
        setTimeout(() => window.location.reload(), 50);
      }
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
